const contentType = {
  "Content-Type": "application/json"
};

export default contentType;
